export const getValidSiteNamesLength = (
    reminderSiteNames: string[],
    validSiteNames: string[],
) =>
    reminderSiteNames.reduce(
        (sum, siteName) => (validSiteNames.includes(siteName) ? sum + 1 : sum),
        0,
    );
